import { getDynamicSemanticToken } from '../../../DesignSystem';
import { getDefaultZoomUI } from '../../../ThemeProvider';
export function getDynamicThemeToken(theme) {
    // Get dynamic semantic design token,
    // which can automatically switch between light and dark content
    const semantic = getDynamicSemanticToken(theme);
    const { shadow, typography } = theme?.zoomUI ?? getDefaultZoomUI();
    return {
        textField: {
            borderColor: semantic.component.input.border,
            borderRadius: {
                small: '6px',
                medium: '8px',
                large: '10px',
                extraLarge: '12px',
            },
            color: semantic.text.stronger.neutral,
            readOnlyColor: semantic.text.neutral,
            disabledColor: semantic.state.disable,
            placeholderColor: semantic.text.neutral,
            fontSize: {
                small: typography.fontSize.subtitle,
                medium: typography.fontSize.body,
                large: '16px' /* typography.fontSize.bodyLarge */,
                extraLarge: '16px' /* typography.fontSize.bodyLarge */,
            },
            height: {
                small: '14px',
                medium: '22px',
                large: '30px',
                extraLarge: '38px',
            },
        },
        icon: {
            size: {
                small: 14,
                medium: 16,
                large: 16,
                extraLarge: 16,
            },
        },
        chip: {
            readOnlyColor: semantic.text.neutral,
        },
        paper: {
            borderColor: semantic.border.subtle.neutral,
            background: semantic.fill.default,
        },
        option: {
            color: semantic.text.strong.primary,
        },
        color: {
            primary: {
                fill: semantic.fill.primary,
                text: semantic.text.primary,
            },
            neutral: {
                default: semantic.text.neutral,
                stronger: semantic.text.stronger.neutral,
            },
        },
        background: {
            secondary: {
                default: semantic.bg.default,
                hover: semantic.state.subtle.neutral.hover,
                active: semantic.state.subtle.neutral.press,
                readOnly: semantic.fill.subtler.neutral,
            },
        },
        border: {
            secondary: {
                default: semantic.component.input.border,
                paper: semantic.border.subtle.neutral,
            },
            error: {
                default: semantic.border.error,
                disabled: semantic.state.subtle.error.disable,
            },
            disabled: semantic.state.subtle.disable,
        },
        helpText: {
            error: semantic.text.error,
            default: semantic.text.neutral,
        },
        boxShadow: {
            pager: shadow.md,
        },
        fontFamily: typography.fontFamily,
        outline: {
            default: 'none',
            focus: `2px solid ${semantic.border.primary}`,
        },
        outlineOffset: 2,
        group: {
            title: {
                color: semantic.text.stronger.neutral,
                fontSize: typography.fontSize.bodyBold,
                fontWeight: typography.fontWeight.bodyBold,
                lineHeight: typography.lineHeight.bodyBold,
            },
            borderColor: semantic.border.subtle.neutral,
        },
    };
}
